export const ACTOR = 'actor'
